module.exports = __webpack_public_path__ + "static/media/Blend 100.1a0dafd7.png";